'use client';
import { getCookie, removeCookie } from '#pplx/frontend/cookies/provider.js';
import { loadTranslations as loadTranslationsCore, matchLocale, PPLX_CHOSEN_LOCALE_COOKIE, } from '#pplx/frontend/i18n/core.js';
import { logger } from '#pplx/frontend/logger/browser.js';
export function loadTranslations(locales, localeTranslations) {
    return loadTranslationsCore(locales, localeTranslations, logger);
}
/**
 * Figure out the chosen locale for a user.
 * The hierarchy is as follows:
 * 1. Query params
 * 2. Cookie
 * 3. Browser language
 */
export function getChosenLocale() {
    const url = new URL(globalThis.location.href);
    const requestedLocales = [
        url.searchParams.get('locale'),
        getCookie(PPLX_CHOSEN_LOCALE_COOKIE),
        globalThis.navigator.language,
    ].filter((v) => !!v);
    return matchLocale(requestedLocales);
}
export function resetChosenLocale() {
    removeCookie(PPLX_CHOSEN_LOCALE_COOKIE);
}
//# sourceMappingURL=browser.js.map